import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Mail, X } from "lucide-react";
import { Button } from "./ui/button";

const API_URL = process.env.REACT_APP_API_URL;
const DISMISS_KEY = "emailVerifyBannerDismissed";

const readUser = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

const EmailVerificationBanner = () => {
  useLocation(); // fuerza re-render en cada navegación (login redirige tras guardar el user)
  const [, forceTick] = useState(0);
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "1",
  );
  const [sending, setSending] = useState(false);

  useEffect(() => {
    const onSync = () => forceTick((n) => n + 1);
    window.addEventListener("user-sync", onSync);
    return () => window.removeEventListener("user-sync", onSync);
  }, []);

  const user = readUser();
  const token = localStorage.getItem("token");

  if (!token || !user || user.emailVerified !== false || dismissed) return null;

  const handleResend = async () => {
    setSending(true);
    try {
      await axios.post(
        `${API_URL}/auth/resend-verification`,
        {},
        { headers: { Authorization: `Bearer ${token}` } },
      );
      toast.success("✅ Correo de verificación reenviado");
    } catch (err) {
      toast.error(
        err.response?.data?.message || "No se pudo reenviar el correo",
      );
    } finally {
      setSending(false);
    }
  };

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "1");
    setDismissed(true);
  };

  return (
    <div className="fixed top-0 inset-x-0 z-[100] flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-800 shadow-sm">
      <div className="flex items-center gap-2">
        <Mail className="h-4 w-4 flex-shrink-0" />
        <span>Confirma tu correo para proteger tu cuenta.</span>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" onClick={handleResend} disabled={sending}>
          {sending ? "Enviando..." : "Reenviar correo"}
        </Button>
        <button
          onClick={handleDismiss}
          className="p-1 rounded-lg text-amber-500 hover:bg-amber-100 hover:text-amber-700"
          aria-label="Cerrar"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
